import React from 'react'
import styles from './VolumeStyles'
import { Icon } from 'semantic-ui-react'

export default ({ onChange, onClick, volume, muted, className, ariaLabelMute, ariaLabelUnmute, ariaLabelVolume }) => {
  const volumeValue = muted || !volume
    ? 0
    : +volume
  const isSilent = muted || volume <= 0
  const volumeHeight = `${volumeValue * 100}%`
  return (
    <div className={styles.component}>
      <Icon
        className={styles.button}
        onClick={onClick}
        name={isSilent
          ? 'volume off'
          : 'volume up'
        } />
      <div className={styles.slider}>
        <div className={styles.track}>
          <div
            className={styles.fill}
            style={{ height: volumeHeight }} />
          <input
            min='0'
            step={0.1}
            max='1'
            type='range'
            orient='vertical'
            onChange={onChange}
            aria-label={ariaLabelVolume}
            className={styles.input}
            value={volumeValue} />
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/Volume/Volume.js